import {
  AppleApiParams,
  CreateAnonymousUserApiParams,
  GoogleApiParams,
  RegisterApiParams,
  Session,
  SessionV2,
  SignInApiParams,
  SignOutParams,
} from "@/types/auth"

import { buildClientAxios } from "@/lib/client-axios"
import { BaseApi } from "./base-api"

export interface ProviderAuthResult {
  session: SessionV2
  registrationOccurred: boolean
}

export class AuthV2Api extends BaseApi {
  constructor() {
    super(buildClientAxios("nextjs"), { skipAuthHandling: true })
  }

  async signIn(params: SignInApiParams): Promise<{ session: SessionV2 }> {
    return await this.post<{ session: SessionV2 }>(
      "/api/auth-v2/sign-in",
      params
    )
  }

  async register(params: RegisterApiParams): Promise<{ session: SessionV2 }> {
    return await this.post<{ session: SessionV2 }>(
      "/api/auth-v2/register",
      params
    )
  }

  async refresh(): Promise<{ session: SessionV2 }> {
    return await this.post<{ session: SessionV2 }>("/api/auth-v2/refresh")
  }

  async signOut(params?: SignOutParams): Promise<void> {
    await this.post<void>("/api/auth-v2/sign-out", params || {})
  }

  async googleProviderAuth(
    params: GoogleApiParams
  ): Promise<ProviderAuthResult> {
    const response = await this.postWithStatus<{ session: SessionV2 }>(
      "/api/auth-v2/provider/google",
      params
    )
    return {
      ...response.data,
      registrationOccurred: response.status === 201,
    }
  }

  async appleProviderAuth(params: AppleApiParams): Promise<ProviderAuthResult> {
    const response = await this.postWithStatus<{ session: SessionV2 }>(
      "/api/auth-v2/provider/apple",
      params
    )
    return {
      ...response.data,
      registrationOccurred: response.status === 201,
    }
  }

  async webHandoff(params: { code: string }): Promise<{ session: SessionV2 }> {
    return await this.post<{ session: SessionV2 }>("/api/auth-v2/web-handoff", {
      verify_web_handoff_code: params.code,
    })
  }

  async createAnonymousUser(
    params: CreateAnonymousUserApiParams
  ): Promise<{ session: SessionV2 }> {
    return await this.post<{ session: SessionV2 }>(
      "/api/auth-v2/create-anonymous-user",
      params
    )
  }

  async getSession(): Promise<{ session: Session }> {
    return await this.get<{ session: Session }>("/api/auth-v2/session")
  }
}
